import { LifeCycle } from '../entities/offsiteCampaign';

export const AllActivityStates = ['Live', 'Paused', 'Scheduled', 'Finished', 'Archived', 'Testing', 'Migration'];
export type ActivityState = typeof AllActivityStates[number];

const isAfterStartTime = (lifeCycle: LifeCycle, time: number): boolean => {
  return !lifeCycle.startTime || time > lifeCycle.startTime;
};

const isBeforeEndTime = (lifeCycle: LifeCycle, time: number): boolean => {
  return !lifeCycle.endTime || time < lifeCycle.endTime;
};

const isInWindow = (lifeCycle: LifeCycle, time: number): boolean => {
  return isAfterStartTime(lifeCycle, time) && isBeforeEndTime(lifeCycle, time);
};

export const getActivityState = (lifeCycle: LifeCycle): ActivityState => {
  switch (lifeCycle.state) {
    case 'ACTIVE':
      const now = Date.now();
      if (isInWindow(lifeCycle, now)) {
        return 'Live';
      }

      if (isAfterStartTime(lifeCycle, now)) {
        return 'Finished';
      }
      return 'Scheduled';

    case 'INACTIVE':
      return 'Paused';

    case 'TESTING':
      return 'Testing';

    case 'DELETED':
      return 'Archived';

    case 'MIGRATION':
      return 'Migration';
  }
};
